export default __webpack_public_path__ + "static/media/img_baseCrochet_green.1a70e47e.jpg";